import {
	COVERGO_SAAS_DEV,
	COVERGO_SAAS_GAMMA,
	COVERGO_ASIA_QA,
	COVERGO_CA_UAT,
	COVERGO_ASIA_NFR,
	COVERGO_CA_PREPROD,
	COVERGO_CA_PROD,
} from "../consts.js"

export const humania_gamma = {
	"humania-studio.gamma.covergo.cloud": {
		appConfig: {
			tenantId: "humania_gamma",
			appId: "covergo_crm",
		},
		envConfig: COVERGO_SAAS_GAMMA,
	},
}

export const humania_dev = {
	"humania-studio.dev.asia.covergo.cloud": {
		appConfig: {
			tenantId: "humania_dev",
			appId: "covergo_crm",
		},
		envConfig: COVERGO_SAAS_DEV,
		// CH-37826: HttpOnly-cookie session auth for this host.
		// MUST stay on the host entry — envConfig objects are shared consts
		// (COVERGO_SAAS_DEV is reused by ~30 hosts) and putting it there would
		// enable cookie mode for every one of them.
		cookieModeEnabled: true,
	},
}

// The correct format should be [tenant]-[appname].[environment].[region].covergo.cloud
// but we removed the [region] part because the certificate on k8s did not have it for NFR
export const humania_nfr = {
	"humania-studio.nfr.covergo.cloud": {
		appConfig: {
			tenantId: "humania_nfr",
			appId: "covergo_crm",
		},
		envConfig: COVERGO_ASIA_NFR,
	},
}

export const humania_qa = {
	"humania-studio.qa.asia.covergo.cloud": {
		appConfig: {
			tenantId: "humania_qa",
			appId: "covergo_crm",
		},
		envConfig: COVERGO_ASIA_QA,
		// CH-37826: HttpOnly-cookie session auth for this host.
		// MUST stay on the host entry — envConfig objects are shared consts and
		// putting it there would enable cookie mode for every host that reuses them.
		cookieModeEnabled: true,
		fileSystem: {
			bucketName: "covergo-apse1-qa-humania-qa"
		}
	},
}

export const humania_uat = {
	"humania-studio.uat.ca.covergo.cloud": {
		appConfig: {
			tenantId: "humania_uat",
			appId: "covergo_crm",
		},
		envConfig: COVERGO_CA_UAT,
		// CH-37826: HttpOnly-cookie session auth for this host.
		// MUST stay on the host entry — envConfig objects are shared consts and
		// putting it there would enable cookie mode for every host that reuses them.
		cookieModeEnabled: true,
		fileSystem: {
			bucketName: "covergo-cace1-uat-humania-uat"
		}
	},
}

export const humania_preprod = {
	"humania-studio.preprod.ca.covergo.cloud": {
		appConfig: {
			tenantId: "humania_preprod",
			appId: "covergo_crm",
		},
		envConfig: COVERGO_CA_PREPROD,
		// CH-37826: HttpOnly-cookie session auth for this host.
		// MUST stay on the host entry — envConfig objects are shared consts and
		// putting it there would enable cookie mode for every host that reuses them.
		cookieModeEnabled: true,
		fileSystem: {
			bucketName: "covergo-cace1-preprod-humania-preprod"
		}
	},
}

export const humania_prod = {
	"humania-studio.ca.covergo.com": {
		appConfig: {
			tenantId: "humania_prod",
			appId: "covergo_crm",
		},
		envConfig: COVERGO_CA_PROD,
		// CH-37826: HttpOnly-cookie session auth for this host.
		// MUST stay on the host entry — envConfig objects are shared consts and
		// putting it there would enable cookie mode for every host that reuses them.
		cookieModeEnabled: true,
		fileSystem: {
			bucketName: "covergo-cace1-prod-humania"
		}
	},
}

